import { AppState } from '@store/AppState';
import type { FC } from 'react';
import { useSelector } from 'react-redux';
import { PortfolioFilterType } from '../../../../../enums/PortfolioFilterType';
import { usePortfolioFilter } from '../../../../../hooks/UsePortfolioFilter';
import type { PortfolioState } from '../../../../../store/portfolio/PortfolioReducer';
import PortfolioStatusDropdown from '../../portfolio-status-dropdown/PortfolioStatusDropdown';

type StatusOptionsProps = {
  onOpen: () => void;
  onClose: () => void;
};

export const StatusOptions: FC<StatusOptionsProps> = ({ onOpen, onClose }) => {
  const { getPortfolioView, setSelectedFilter } = usePortfolioFilter();
  const { dealType } = useSelector<AppState, PortfolioState>(
    (portfolioState) => portfolioState.portfolio,
  );
  const currentView = getPortfolioView(dealType);

  return (
    <PortfolioStatusDropdown
      onChange={(val) => setSelectedFilter(PortfolioFilterType.Status, val, dealType)}
      options={currentView?.filters.status}
      onOpen={onOpen}
      onClose={onClose}
      value={currentView?.selectedFilters.status}
    />
  );
};
